import { useEffect } from 'react'

export const useMetaTags = (metaData) => {
  useEffect(() => {
    if (!metaData) return

    // Função para atualizar ou criar meta tag
    const updateMetaTag = (property, content) => {
      if (!content) return
      
      let metaTag = document.querySelector(`meta[property="${property}"]`)
      if (!metaTag) {
        metaTag = document.createElement('meta')
        metaTag.setAttribute('property', property)
        document.head.appendChild(metaTag)
      }
      metaTag.setAttribute('content', content)
    }

    // Função para atualizar title
    const updateTitle = (title) => {
      if (title) {
        document.title = title
      }
    }

    // Atualizar meta tags Open Graph
    updateTitle(metaData.title)
    updateMetaTag('og:title', metaData.title)
    updateMetaTag('og:description', metaData.description)
    updateMetaTag('og:type', 'website')
    updateMetaTag('og:url', window.location.href)
    updateMetaTag('og:site_name', 'PedidoFácil')
    
    // Meta tags específicas para WhatsApp
    updateMetaTag('og:image', metaData.image || '/vite.svg')
    updateMetaTag('og:image:width', '1200')
    updateMetaTag('og:image:height', '630')
    updateMetaTag('og:image:alt', metaData.title)
    
    // Twitter Cards
    updateMetaTag('twitter:card', 'summary_large_image')
    updateMetaTag('twitter:title', metaData.title)
    updateMetaTag('twitter:description', metaData.description)
    updateMetaTag('twitter:image', metaData.image || '/vite.svg')
    
    // Meta tags adicionais
    let descriptionMeta = document.querySelector('meta[name="description"]')
    if (descriptionMeta) {
      descriptionMeta.setAttribute('content', metaData.description)
    }
    
    // Meta tag para keywords (opcional)
    if (metaData.keywords) {
      let keywordsMeta = document.querySelector('meta[name="keywords"]')
      if (!keywordsMeta) {
        keywordsMeta = document.createElement('meta')
        keywordsMeta.setAttribute('name', 'keywords')
        document.head.appendChild(keywordsMeta)
      }
      keywordsMeta.setAttribute('content', metaData.keywords)
    }

    // Cleanup function para restaurar meta tags originais
    return () => {
      document.title = 'PedidoFácil - Fornecedor'
      const originalDescription = 'PedidoFácil - Plataforma moderna para gestão de cotações'
      if (descriptionMeta) {
        descriptionMeta.setAttribute('content', originalDescription)
      }
    }
  }, [metaData])
}